export default __webpack_public_path__ + "static/KV_AD_5231_rgb-8d8780769e83840364cd7809eaff2db7.jpg";